import {omit} from 'ramda'
import {Metric} from 'web-vitals'

export const toPerformanceMeasuredContext = (data: Metric) => ({
  ...omit(['name'], data),
  metric: data.name
})
